import {
  isPartialMultiShadeCharacteristics,
  type DeepPartial,
  type MultiShadeCharacteristics,
  type ShadeCharacteristics,
  type UniformShadeCharacteristics,
} from "@jasper/client-models";

export const normalizeShadeCharacteristics = ({
  value,
  itemShades,
}: {
  value: DeepPartial<ShadeCharacteristics>;
  itemShades: { value: string; shadeType?: string }[];
}) => {
  if (!value) return value;

  const next = { ...value };

  if (next.isMultiShade == null) {
    next.isMultiShade = false;
  }

  const isCompatible = (shade?: string, shadeType?: string) =>
    !!shade &&
    !!shadeType &&
    itemShades.some(s => s.value === shade && s.shadeType === shadeType);

  if (!next.isMultiShade) {
    (next as Partial<MultiShadeCharacteristics>).baseShade = undefined;
    (next as Partial<MultiShadeCharacteristics>).incisalShade = undefined;
    (next as Partial<MultiShadeCharacteristics>).gingivalShade = undefined;
    if ("shade" in next && !isCompatible(next.shade, next.shadeType)) {
      next.shade = undefined;
    }
  }

  if (next.isMultiShade && isPartialMultiShadeCharacteristics(next)) {
    (next as Partial<UniformShadeCharacteristics>).shade = undefined;

    next.baseShade = isCompatible(next.baseShade, next.shadeType)
      ? next.baseShade
      : undefined;
    next.incisalShade = isCompatible(next.incisalShade, next.shadeType)
      ? next.incisalShade
      : undefined;
    next.gingivalShade = isCompatible(next.gingivalShade, next.shadeType)
      ? next.gingivalShade
      : undefined;
  }

  return next;
};
